import { render } from "./mallList.vue?vue&type=template&id=1bd1af3a&scoped=true"
import script from "./mallList.vue?vue&type=script&lang=js"
export * from "./mallList.vue?vue&type=script&lang=js"

import "./mallList.vue?vue&type=style&index=0&id=1bd1af3a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd1af3a"]])

export default __exports__